import { render, staticRenderFns } from "./11TravellerInfo.vue?vue&type=template&id=345ce6de"
import script from "./11TravellerInfo.vue?vue&type=script&lang=js"
export * from "./11TravellerInfo.vue?vue&type=script&lang=js"
import style0 from "./11TravellerInfo.vue?vue&type=style&index=0&id=345ce6de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports